import { SortByConfig, SortableTable } from "components/Table/Table";
import { MachineOverview } from "interfaces/machine-overview";

import { Paper } from "@mui/material";
import { styled } from "@mui/material/styles";
import { getMachineTableColumns } from "components/OverviewPages/getMachineTableColumns";
import { useContext } from "react";
import { FeaturesContext } from "contexts/FeaturesContext";

export interface MachineTableProps {
  machineTableData: MachineOverview[];
  loading: boolean;
}

const MachineTableDefaultSort: SortByConfig[] = [
  {
    id: "component",
    desc: false
  }
];

export const MachineTable = ({
  machineTableData,
  loading
}: MachineTableProps): JSX.Element => {
  const { hasFeature } = useContext(FeaturesContext);

  return (
    <MachineTableScroll elevation={0}>
      <SortableTable
        data={machineTableData}
        columns={getMachineTableColumns(hasFeature)}
        loading={loading}
        dataQa="site-table"
        defaultSortBy={MachineTableDefaultSort}
      />
    </MachineTableScroll>
  );
};

const MachineTableScroll = styled(Paper)`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: auto;
  margin: 24px;
  border: 1px solid rgba(224, 224, 224, 1);
  border-radius: 4px;
`;
